import Rule from './rule';

export default class CalcRule extends Rule {
  constructor(ruleText, attribute,active) {
    super(ruleText, attribute,active);
    this.ruleType = 'CALC';
    this.compile(ruleText);
    this.ops = {
      '+': (a, b) => a + b,
      '-': (a, b) => a - b,
      '*': (a, b) => a * b,
      '/': (a, b) => a / b,
      '%': (a, b) => a % b,
    };
  }

  compile(text) {
    const rule = text.replace(/^\s?calc /i, '');
    this.args = rule.split(/\s/i).map(arg => arg.trim());
  }

  run(input, headers, resolve) {
    const arg = headers.includes(this.args[1]) ? resolve(this.args[1]) : this.args[1];
    const res = this.ops[this.args[0]](Number(input), +arg);
    return !isNaN(res) ? `${res}` : input;
  }

  validate() {
    return this.args.length === 2 && Object.keys(this.ops).includes(this.args[0]);
  }
}
